import { transformDetailsOfExpensesReportToTableData } from './transformDetailsOfExpensesReportToTableData';

export { transformDetailsOfExpensesReportToTableData };
